import { BrowserRouter, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { useEffect, lazy, Suspense } from 'react';
import LoginPage from './pages/LoginPage';
import PrivateRoute from './components/PrivateRoute';
import LayoutShell from './components/layout/LayoutShell';
import { LoadingIndicator } from './components/feedback/LoadingIndicator';
import { ToastContainer } from './components/feedback/ToastContainer';
import { useAuthStore } from './store/authStore';

const ChatPage = lazy(() => import('./pages/ChatPage'));
const ImpersonatePage = lazy(() => import('./pages/ImpersonatePage'));

function AppContent() {
  const { isAuthenticated } = useAuthStore();
  const navigate = useNavigate();

  // Listen for auth logout events from API interceptor
  useEffect(() => {
    const handleLogout = () => {
      navigate('/login');
    };
    window.addEventListener('auth:logout', handleLogout);
    return () => window.removeEventListener('auth:logout', handleLogout);
  }, [navigate]);

  return (
    <Suspense fallback={<LoadingIndicator size="lg" />}>
      <Routes>
        {/* Login route - redirect to chat if already authenticated */}
        <Route
          path="/login"
          element={isAuthenticated ? <Navigate to="/" replace /> : <LoginPage />}
        />

        {/* Impersonation route - SaaS admin login as tenant user */}
        <Route path="/impersonate" element={<ImpersonatePage />} />

        {/* Protected chat route — LayoutShell provides header, sidebar, and <Outlet /> */}
        <Route
          element={
            <PrivateRoute>
              <LayoutShell />
            </PrivateRoute>
          }
        >
          <Route path="/" element={<ChatPage />} />
          <Route path="/chat" element={<ChatPage />} />
          <Route path="/chat/:sessionId" element={<ChatPage />} />
        </Route>

        {/* Catch-all redirect */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
      <ToastContainer />
    </BrowserRouter>
  );
}

export default App;
